import React from "react";
import { Label, SwitchContainer, Toggle } from "./Switch.styled";

interface SwitchProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  minWidth?: string;
  disabled?: boolean;
}

const Switch: React.FC<SwitchProps> = ({ label, checked, onChange, minWidth,  disabled}) => {
  return (
    <SwitchContainer minWidth={minWidth} $disabled={disabled}>
      <Toggle
        checked={checked}
        onClick={() => {
          if (!disabled) {
            onChange(!checked);
          }
        }}
        $disabled={disabled}
      />
      <Label>{label}</Label>
    </SwitchContainer>
  );
};

export default Switch;
